import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import log from 'loglevel';
import {
  Box,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Popover,
  Typography,
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from '../../../../hooks/useAuth';
import { ROUTES } from '../../../../consts';
import { style } from './style';

interface AccountPopoverProps {
  anchorEl: null | Element;
  onClose: () => void;
  open: boolean;
}

const TAG = '[ACCOUNT_MENU_COMPONENT]';

const AccountMenu: FC<AccountPopoverProps> = (props) => {
  const {
    anchorEl, onClose, open,
  } = props;
  const { logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = async (): Promise<void> => {
    try {
      onClose();
      await logout();
      navigate(ROUTES.LOGIN);
    } catch (err) {
      // TODO should add error notification
      log.error(TAG, 'failed to logout', err);
    }
  };

  return (
    <Popover
      anchorEl={ anchorEl }
      anchorOrigin={ style.main.anchorOrigin }
      keepMounted
      onClose={ onClose }
      open={ open }
      PaperProps={ { sx: style.main.sx } }
      transitionDuration={ 0 }
    >
      <Box sx={ style.box.sx }>
        <MenuItem onClick={ handleLogout }>
          <ListItemIcon>
            <LogoutIcon fontSize={ style.box.fontSize } />
          </ListItemIcon>
          <ListItemText
            primary={ (
              <Typography variant={ style.box.variant }>
                Logout
              </Typography>
            ) }
          />
        </MenuItem>
      </Box>
    </Popover>
  );
};

export default AccountMenu;
